import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { exportPdf } from "utils";
import { ExportExcelRequestForm } from "./ExportExcelRequestForm";
import { ExportPdfRequestForm } from "./ExportPdfRequestForm";
import { useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import { DataType } from "../types";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportRequestForm(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data } = useListExportNew("rquest", {
        buy: fill.dateFrom,
        inventory: fill.dateTo,
        isbuild: fill.transfer_status,
        jumlah_item: amount
    })

    return (

        <ModalConfirmExport
            isOpen={true}
            setIsOpen={props.setIsOpen}
            amount={amount}
            setAmount={setAmount}
            title="Item Request Form"
            type={props.type as "excel" | "pdf"}
            total={data.total_record}
            onExport={() => {
                if (props.type === "excel") {
                    ExportExcelRequestForm({
                        data: data.items as DataType[],
                        module: "INVENTORY",
                        title: "REGISTER REQUEST FORM",
                        fileName: "register_request_form",
                        activeColumns: activeColumn!
                    });
                }

                if (props.type === "pdf") {
                    const documentComponent = (
                        <ExportPdfRequestForm data={data.items as DataType[]} tableActive={activeColumn!} />
                    )
                    exportPdf({ documentComponent, fileName: "register_request_form" })
                }
            }}
        />
    )
}